import { render, staticRenderFns } from "./Green.vue?vue&type=template&id=4f67e513&"
import script from "./Green.vue?vue&type=script&lang=js&"
export * from "./Green.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports